export default "__VITE_ASSET__D0z_2nQ___"